import React, { Fragment, useEffect, useState } from 'react'
import {
  Box,
  Collapse,
  Grid,
  IconButton,
  Paper,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import {
  eInventoryCheckState,
  eTypeInventoryCheck
} from '../../../enums/eInventoryCheck'
import { useApi } from '../../../hooks/useApi'
import {
  InventoryCheckDetail,
  InventoryCheckEntity
} from '../entities/InventoryCheck'
import { Loading } from '../../../components/UI'
import { Status } from '../../../hooks/useFetchState'
import { getInventoryCheckDetail } from '../api'
import { formatNonUTCDate, utcToLocal } from '../../../utils/dateHelper'
import { GenericTable } from '../../../components/_EOS/Table/GenericTable'
import { generateTableHeadersInventoryCheckDetail } from '..'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { InventoryCheckBlogComponent } from './ViewInventoryCheckBlogComponent'

interface ViewInventoryCheckModalProps {
  inventoryCheckId: number
  handleSnackbar: (message: string, success: boolean) => void
}

export const ViewInventoryCheckModal: React.FC<
  ViewInventoryCheckModalProps
> = ({ inventoryCheckId, handleSnackbar }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { state, callApi } = useApi<InventoryCheckEntity>()

  const [open, setOpen] = useState<boolean>(false)
  const classes = useStyles()

  const tableHeadersInventoryCheckDetail =
    generateTableHeadersInventoryCheckDetail()

  const requestInventoryCheckDetail = () => {
    setLoading(true)
    callApi(getInventoryCheckDetail(inventoryCheckId))
      .then(() => {
        setLoading(false)
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
    setLoading(false)
  }

  useEffect(() => {
    requestInventoryCheckDetail()
  }, [])

  if (state.status === Status.Loading || loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  } else {
    return (
      <Fragment>
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          spacing={1}
          style={{ paddingLeft: '40px', paddingTop: '10px' }}
        >
          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Id:</b>
              {` ${state.data?.inventoryCheckId || ''}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Estado:</b>
              {state.data?.stateId &&
                ` ${eInventoryCheckState[state.data?.stateId]}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Estado:</b>
              {state.data?.typeInventoryCheckId &&
                ` ${eTypeInventoryCheck[state.data?.typeInventoryCheckId]}`}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Fecha Creación:</b>
              {` ${utcToLocal(state.data?.createdDate, 'dd/MM/yyyy')}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Fecha Compromiso:</b>
              {` ${formatNonUTCDate(state.data?.promiseDate, 'dd/MM/yyyy')}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Fecha Finalización:</b>
              {` ${utcToLocal(state.data?.endDate, 'dd/MM/yyyy')}`}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Posiciones:</b>
              {` ${state.data?.totalPosition || 0}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Avance:</b>
              {` ${state.data?.progress || 0}%`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Total Ciclos:</b>
              {` ${state.data?.qtyCycles || 0}`}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Tag:</b>
              {` ${state.data?.tag || ''}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant='body2' component='p'>
              <b>Usuario Creador:</b>
              {` ${state.data?.userCreated || 'Sin Usuario'}`}
            </Typography>
          </Grid>
        </Grid>
        <hr />
        <InventoryCheckBlogComponent inventoryCheckId={inventoryCheckId} />

        <hr />
        <div
          className={classes.accordeonSummary}
          onClick={() => setOpen(!open)}
          style={{ cursor: 'pointer' }}
        >
          <Typography variant='subtitle1' style={{ fontWeight: 'bold' }}>
            Detalle Posiciones
          </Typography>
          <IconButton size='small'>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
        <Collapse in={open} timeout='auto' unmountOnExit>
          <Box overflow={'auto'} maxHeight={'250px'} component={Paper}>
            <GenericTable<InventoryCheckDetail>
              headersConfig={tableHeadersInventoryCheckDetail}
              data={state.data?.details}
              IDKey={'inventoryCheckDetailId'}
              noResultsText='No existe información'
              isLoading={loading}
            />
          </Box>
        </Collapse>
      </Fragment>
    )
  }
}

const useStyles = makeStyles(() => ({
  accordeonSummary: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, .03)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    },
    justifyContent: 'space-between',
    paddingLeft: '16px',
    border: '1px solid rgba(0, 0, 0, .125)',
    borderRadius: '4px',
    borderBottom: '2px solid rgba(0, 0, 0, .125)'
  }
}))
